import { memo } from "react";
import { makeStyles } from "@mui/styles";

import { View } from "../Base";
import SectionItem from "./SectionItem";

const useStyles = makeStyles(({ typography }) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  list: {
    overflow: "auto",
    marginRight: "-14px",
  },
}));

const Sections = memo(({ sections }) => {
  const styles = useStyles();

  return (
    <View className={styles.container}>
      <View className={styles.list}>
        {sections.map((section) => (
          <SectionItem key={section.sectionCode.toString()} section={section} />
        ))}
      </View>
    </View>
  );
});

export default Sections;
